<template>
  <fields-placeholder v-if="!loaded"></fields-placeholder>
  <div v-else>
    <div class="island">
      <component
        :is="contentBlockComponent"
        :key="'tab-info-' + selectedTab.id"
        content-block-key="tab-info"
        :content-block="contentBlock"
        model-name="Tab"
        :model-id="selectedTab.id"
      />
    </div>
    <keep-alive>
      <component
        :is="tabComponent"
        v-if="selectedTab"
        :key="'tab-' + '-' + selectedTab.type + '-' + selectedTab.slug"
        :tab="selectedTab"
        :transition="transition"
      />
    </keep-alive>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import components from './index';
import FieldsPlaceholder from './../Fields/FieldsPlaceholder.vue';
import ContentBlock from '@/lib/components/ContentBlocks/ContentBlock';
import EditableContentBlock from '@/lib/components/ContentBlocks/EditableContentBlock';

export default {
  components: {
    ...components,
    FieldsPlaceholder,
    ContentBlock,
    EditableContentBlock
  },
  props: {
    loaded: {
      type: Boolean,
      required: true
    },
    transitions: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters('entryForm', ['selectedTab']),
    ...mapState('entryForm', ['hasManagerRole', 'contentBlocks']),
    transition() {
      return this.transitions ? 'push' : '';
    },
    tabComponent() {
      return this.selectedTab.type + 'Tab';
    },
    contentBlockComponent() {
      return this.hasManagerRole ? 'EditableContentBlock' : 'ContentBlock';
    },
    contentBlock() {
      return this.contentBlocks.find(
        c => c.id === this.selectedTab.contentblockId
      );
    }
  },
  created() {
    window.addEventListener('popstate', this.popstateListener);
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.popstateListener);
  },
  methods: {
    ...mapActions('entryForm', ['selectTabBySlug']),
    popstateListener(e) {
      this.selectTabBySlug(e.state.slug);
    }
  }
};
</script>
